import { authHeader } from 'Services/helpers/authHeader';

export function downloadHeadersWithAuth() {
  let headers = authHeader();
  //headers['Content-Type'] = 'application/octet-stream';
  headers['Content-Disposition'] = 'attachment';

  return headers;
}